export function transformOptions(fetchOptions, shorthandOptions) {
    if (fetchOptions.headers) {
        fetchOptions.headers = new Headers(fetchOptions.headers instanceof Headers
            ? Object.fromEntries(fetchOptions.headers.entries())
            : fetchOptions.headers);
    }
    if (!fetchOptions.headers) {
        fetchOptions.headers = new Headers();
    }
    if (shorthandOptions.json) {
        return transformJsonOption(fetchOptions, shorthandOptions);
    }
    if (shorthandOptions.form) {
        return transformFormOption(fetchOptions, shorthandOptions);
    }
    return fetchOptions;
}
export function transformJsonOption(fetchOptions, shorthandOptions) {
    if (fetchOptions.headers) {
        fetchOptions.headers.set('Content-Type', 'application/json');
    }
    return {
        ...fetchOptions,
        method: 'POST',
        body: JSON.stringify(shorthandOptions.json),
    };
}
export function transformFormOption(fetchOptions, shorthandOptions) {
    if (fetchOptions.headers) {
        fetchOptions.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }
    return {
        ...fetchOptions,
        method: 'POST',
        body: new URLSearchParams(shorthandOptions.form).toString(),
    };
}
export function getRetryAfterMs(headers) {
    const retryAfter = headers.get('Retry-After');
    if (!retryAfter) {
        return;
    }
    if (Number.isNaN(Number(retryAfter))) {
        return Math.max(new Date(retryAfter).getTime() - Date.now(), 0) || 0;
    }
    return Number(retryAfter) * 1000;
}
